import { FieldSizeSemantic } from './constants.js';
import get from 'lodash.get';
import { getThemeTextStyleValues } from '@doordash/design-language';

var getThemeFieldTextStyles = function getThemeFieldTextStyles(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      styleType = _ref.styleType;
  var densityString = "".concat(get(theme, 'Typography.Density'), "Density");
  var textStylesDef = get(theme, "Typography.TextStyles.".concat(FieldSizeSemantic[size]).concat(styleType));
  var mobileStyles = getThemeTextStyleValues({
    completeSemanticDefinition: textStylesDef,
    themeDensityString: densityString
  });
  var desktopStyles = getThemeTextStyleValues({
    completeSemanticDefinition: textStylesDef,
    themeDensityString: densityString,
    includeDesktopOverrides: true
  });
  return {
    mobile: mobileStyles,
    desktop: desktopStyles
  };
};

export { getThemeFieldTextStyles };
